import React from 'react';
import {inputStyles, selectStyles} from '../styles';
import {sanitizePositiveInteger} from '../utils';

interface NumberInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  width?: number | string;
  maxLength?: number;
}

/** Entiers positifs uniquement : la saisie est filtrée à la frappe. */
export const NumberInput = ({
  value,
  onChange,
  label,
  placeholder,
  disabled = false,
  width = 68,
  maxLength,
}: NumberInputProps) => (
  <div style={{...inputStyles.container, width}}>
    {label && <label style={selectStyles.label}>{label}</label>}
    <input
      type="text"
      inputMode="numeric"
      maxLength={maxLength}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={event => onChange(sanitizePositiveInteger(event.target.value))}
      style={{
        ...inputStyles.field,
        ...(disabled ? inputStyles.fieldDisabled : {}),
      }}
    />
  </div>
);

export default NumberInput;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/components/NumberInput.tsx